export default __webpack_public_path__ + "a947bf020b26ea85daa17dfd2a1a17e902ab18ff/feae26866cdcf63baa9b2b9cf6eff4ee.png";